module.exports = __webpack_public_path__ + "static/img/banner-index.7ab1ef1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-index.png
// module id = EK6+
// module chunks = 1